import { render, staticRenderFns } from "./Domain.vue?vue&type=template&id=64486658&scoped=true"
import script from "./Domain.vue?vue&type=script&lang=js"
export * from "./Domain.vue?vue&type=script&lang=js"
import style0 from "./Domain.vue?vue&type=style&index=0&id=64486658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64486658",
  null
  
)

export default component.exports